module.exports = __webpack_public_path__ + "static/media/gym-1.f58c3ed9.jpg";